/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, DestroyRef, effect, input, OnInit, Signal, inject } from '@angular/core';
import {AutoCompleteCompleteEvent, AutoCompleteSelectEvent} from 'primeng/autocomplete';

import {PrimeNgModule} from '@app/shared/modules/prime-ng/prime-ng.module';

import {takeUntilDestroyed, toSignal} from '@angular/core/rxjs-interop';
import {FormsModule} from '@angular/forms';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {EActionStatus} from '@app/shared/enums/action-status.enum';
import {ISearchState} from '@app/shared/models/search-state.model';
import {searchAction} from '@app/shared/state/search/search.actions';
import {selectSearchState} from '@app/shared/state/search/search.selectors';
import {Store} from '@ngrx/store';
import {TranslateModule} from '@ngx-translate/core';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-algolia-search',
  imports: [PrimeNgModule, FormsModule, TranslateModule],
  templateUrl: './algolia-search.component.html',
  styleUrl: './algolia-search.component.scss',
})
export class AlgoliaSearchComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  searchQuery: string = '';
  minQueryLength = 3;
  public refine: ((query: string) => void) | undefined;
  public query: string = '';
  algoliaSuggestionsList: SelectItem[] = [];

  loading = false;

  readonly customerCountryId = input<number>(0);
  readonly customerOrganizationId = input<number>(0);
  selectedSearchItemName = '';

  searchState: Signal<ISearchState>;
  constructor() {
    this.searchState = toSignal(this.store.select(selectSearchState), {
      initialValue: {
        status: EActionStatus.Initial,
        successResponse: null,
        failureReason: '',
        errorMessage: '',
      },
    });
    effect(() => {
      const state = this.searchState();
      if (state.successResponse) {
        this.algoliaSuggestionsList = [];
        const mergedAndRanked = state.successResponse.results;
        mergedAndRanked.slice(0, 5).forEach(item => {
          const trimmedLabel = item.name.length > 70 ? item.name.slice(0, 70) + '...' : item.name;

          this.algoliaSuggestionsList.push({
            label: trimmedLabel,
            value: item,
          });
        });
      }
    });
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const term = params['query'] ?? '';
      this.selectedSearchItemName = term;
    });

    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event instanceof NavigationEnd && !event.urlAfterRedirects.startsWith('/search-results')) {
        this.selectedSearchItemName = '';
      }
    });
  }

  onSearch(autoCompleteEvent?: AutoCompleteCompleteEvent) {
    if (autoCompleteEvent) {
      const query = autoCompleteEvent.query;
      if (query && query.length < this.minQueryLength) {
        return;
      }
      this.algoliaSuggestionsList = [];
      this.searchQuery = query;

      this.store.dispatch(
        searchAction({
          request: {
            term: query,
            pageNumber: 1,
            pageSize: 200,
            organizationId: this.customerOrganizationId(),
            countryId: this.customerCountryId(),
          },
        })
      );
    }
  }

  onClear() {}
  onOptionSelection(selectedItem: AutoCompleteSelectEvent) {
    const item = selectedItem.value.value;
    this.selectedSearchItemName = selectedItem.value.label;
    if (item['objectType'] == 'option') {
      this.router.navigate(['/product'], {
        queryParams: {id: item['productId'], variantId: item['objectID']},
      });
    } else if (item['objectType'] == 'product') {
      this.router.navigate(['/product'], {
        queryParams: {id: item['objectID']},
      });
    }
  }

  handleFullSearch() {
    this.router.navigate(['/search-results'], {
      queryParams: {query: this.selectedSearchItemName},
    });
  }
}
